import { render, staticRenderFns } from "./PICK_two_column_fullbleed.vue?vue&type=template&id=b4690976&"
import script from "./PICK_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./PICK_two_column_fullbleed.vue?vue&type=script&lang=js&"
import style0 from "./PICK_two_column_fullbleed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports